import { render, staticRenderFns } from "./form-box.vue?vue&type=template&id=6f031e86&scoped=true"
import script from "./form-box.vue?vue&type=script&lang=js"
export * from "./form-box.vue?vue&type=script&lang=js"
import style0 from "./form-box.vue?vue&type=style&index=0&id=6f031e86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f031e86",
  null
  
)

export default component.exports